// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".LangSwitcher__root___QwuB1 {\n  width: unset;\n  min-width: 100px;\n}\n", "",{"version":3,"sources":["webpack://./src/components/Post/LangSwitcher/LangSwitcher.styl"],"names":[],"mappings":"AAAA;EACE,YAAM;EACN,gBAAU;AACZ","sourcesContent":[".root\n  width unset\n  min-width 100px\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "LangSwitcher__root___QwuB1"
};
export default ___CSS_LOADER_EXPORT___;
